export default "__VITE_ASSET__fKEPIUIj__"